/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ManagementRole } from './ManagementRole';
import {
    ManagementRoleFromJSON,
    ManagementRoleFromJSONTyped,
    ManagementRoleToJSON,
    ManagementRoleToJSONTyped,
} from './ManagementRole';
import type { FleetRole } from './FleetRole';
import {
    FleetRoleFromJSON,
    FleetRoleFromJSONTyped,
    FleetRoleToJSON,
    FleetRoleToJSONTyped,
} from './FleetRole';
import type { LengthUnit } from './LengthUnit';
import {
    LengthUnitFromJSON,
    LengthUnitFromJSONTyped,
    LengthUnitToJSON,
    LengthUnitToJSONTyped,
} from './LengthUnit';

/**
 * 
 * @export
 * @interface UserUpdate
 */
export interface UserUpdate {
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    employeeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    email?: string | null;
    /**
     * 
     * @type {ManagementRole}
     * @memberof UserUpdate
     */
    managementRole?: ManagementRole | null;
    /**
     * 
     * @type {FleetRole}
     * @memberof UserUpdate
     */
    fleetRole?: FleetRole | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    jobTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    departmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    shiftId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    siteId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UserUpdate
     */
    licenseExpiryDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    expiryLogout?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    nfcToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    nfcTokenDescription?: string | null;
    /**
     * 
     * @type {LengthUnit}
     * @memberof UserUpdate
     */
    lengthUnit?: LengthUnit | null;
}



/**
 * Check if a given object implements the UserUpdate interface.
 */
export function instanceOfUserUpdate(value: object): value is UserUpdate {
    return true;
}

export function UserUpdateFromJSON(json: any): UserUpdate {
    return UserUpdateFromJSONTyped(json, false);
}

export function UserUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
        'password': json['password'] == null ? undefined : json['password'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'managementRole': json['managementRole'] == null ? undefined : ManagementRoleFromJSON(json['managementRole']),
        'fleetRole': json['fleetRole'] == null ? undefined : FleetRoleFromJSON(json['fleetRole']),
        'jobTitle': json['jobTitle'] == null ? undefined : json['jobTitle'],
        'departmentId': json['departmentId'] == null ? undefined : json['departmentId'],
        'shiftId': json['shiftId'] == null ? undefined : json['shiftId'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'licenseExpiryDate': json['licenseExpiryDate'] == null ? undefined : (new Date(json['licenseExpiryDate'])),
        'expiryLogout': json['expiryLogout'] == null ? undefined : json['expiryLogout'],
        'nfcToken': json['nfcToken'] == null ? undefined : json['nfcToken'],
        'nfcTokenDescription': json['nfcTokenDescription'] == null ? undefined : json['nfcTokenDescription'],
        'lengthUnit': json['lengthUnit'] == null ? undefined : LengthUnitFromJSON(json['lengthUnit']),
    };
}

export function UserUpdateToJSON(json: any): UserUpdate {
    return UserUpdateToJSONTyped(json, false);
}

export function UserUpdateToJSONTyped(value?: UserUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employeeId'],
        'password': value['password'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'managementRole': ManagementRoleToJSON(value['managementRole']),
        'fleetRole': FleetRoleToJSON(value['fleetRole']),
        'jobTitle': value['jobTitle'],
        'departmentId': value['departmentId'],
        'shiftId': value['shiftId'],
        'siteId': value['siteId'],
        'licenseExpiryDate': value['licenseExpiryDate'] == null ? value['licenseExpiryDate'] : value['licenseExpiryDate'].toISOString(),
        'expiryLogout': value['expiryLogout'],
        'nfcToken': value['nfcToken'],
        'nfcTokenDescription': value['nfcTokenDescription'],
        'lengthUnit': LengthUnitToJSON(value['lengthUnit']),
    };
}

